import { Injectable } from '@angular/core';
import { HttpRequest, HttpResponse } from '@angular/common/http';

const maxAge = 300000; // maximum allowed cache age in milliseconds. 300.000 = 5min
@Injectable()
export class RequestCache {
  cache = new Map();

  get(req: HttpRequest<unknown>): HttpResponse<unknown> | undefined {
    const cached = this.cache.get(this.createKey(req));

    // no cache hit!
    if (!cached) {
      return undefined;
    }

    // cache too old!
    if (cached.lastRead < Date.now() - maxAge) {
      return undefined;
    }

    // return cache, no server request necessary
    return cached.response;
  }

  put(req: HttpRequest<unknown>, response: HttpResponse<unknown>) {
    const url = this.createKey(req);

    const entry = { url, response, lastRead: Date.now() };
    this.cache.set(url, entry);

    const expired = Date.now() - maxAge;
    this.cache.forEach(expiredEntry => {
      if (expiredEntry.lastRead < expired) {
        this.cache.delete(expiredEntry.url);
      }
    });
  }

  private createKey(req: HttpRequest<unknown>): unknown {
    if (req.method === 'GET') {
      return req.urlWithParams;
    }

    if (req.method === 'POST' && req.body) {
      return JSON.stringify(req.body);
    }
    return req.body;
  }
}
